import ImageService from '@/services/ImageService'
 
import AppStore from 'src/store/app'
import { HOME, PATHS } from '@/config/app'
import Env from 'src/config/env'
import AnimationConfig from 'src/config/animation'

import { clamp, map, DEG_TO_RAD, mix } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from 'src/helpers/EventEmitter'
  
import BaseGroup from '@/components/stage/common/base_group'
 
import gsap  from 'gsap/all'
import dat from 'dat.gui' 

const THREE = require('three') 

import Sprite from '@/components/stage/common/sprite'
import SpritesheetData from '@/config/spritesheets/face'


const Events = {}
 

class Bubble extends BaseGroup {

  constructor(config) { 

    super(config)  
 
    this.Events = Events
    Object.assign(this, config)
    Object.assign(this, EventEmitter)

    this.loopIn = false
    this.expoOut = gsap.parseEase("expo.out")
    this.options = {
      offset: {
        x: -1.3,
        y: -1.8
      }
    }
    this.tweenObj = {
      offset: { 
        y: -200
      },
      mixAmt: 0,
      fiveStar: {
        tgx: 0,
        tgy: 0
      },
      fourStar: {
        tgx: 0,
        tgy: 0
      },
      threeStar: {
        tgx: 0,
        tgy: 0
      },
      twoStar: {
        tgx: 0,
        tgy: 0
      },
      oneStar: {
        tgx: 0,
        tgy: 0
      } 
    }
    this.prevTl = null
    this.pointer = { 
      tgx: 0,
      tgy: 0 
    }
    this.tgx = 0
    this.tgy = 0 
    this.mouseThrottle = 0
    this.render = false
    this.transition_options = null
    this.prev_transition_options = null
    this.setup()
    this.resize() 
  }

  setup() {

    this.pointer.tgx = 5 * DEG_TO_RAD
    this.pointer.tgy = this.reduced_motion ? 0 : ( -10 * DEG_TO_RAD )
    this.pointerMove()
    this.addGUI() 

    this.tlFive = gsap.timeline({repeat: -1, paused: true, onUpdate: ()=>{
      this.tgx = this.tweenObj.fiveStar.tgx
      this.tgy = this.tweenObj.fiveStar.tgy
    }})
    this.tlFive.to(this.tweenObj.fiveStar, 1, {tgx: 10, tgy: 10, ease: 'back.out(5)' })
    this.tlFive.to(this.tweenObj.fiveStar, 2, {tgx: 3,tgy: -20, ease: 'back.out(3)' })
    this.tlFive.to(this.tweenObj.fiveStar, 2, {tgx: 12,tgy: 2, ease: 'expo.out' })
    this.tlFive.to(this.tweenObj.fiveStar, 1.3, {tgx: -5, tgy: 20, ease: 'expo.inOut' })
    this.tlFive.to(this.tweenObj.fiveStar, 1.1, {tgx: 5,tgy: 1, ease: 'expo.inOut' })
    this.tlFive.to(this.tweenObj.fiveStar, 1, {tgx: -10, tgy: 0, ease: 'expo.inOut' })
    this.tlFive.to(this.tweenObj.fiveStar, 2, {tgx: 0, tgy: -10, ease: 'expo.out' })
    this.tlFive.to(this.tweenObj.fiveStar, 2, {tgx: 10, tgy: 25, ease: 'expo.inOut' })
    this.tlFive.to(this.tweenObj.fiveStar, 3, {tgx: 0, tgy: 0, ease: 'expo.inOut' })
 

    this.tlFour = gsap.timeline({repeat: -1, paused: true, onUpdate: ()=>{
      this.tgx = this.tweenObj.fourStar.tgx
      this.tgy = this.tweenObj.fourStar.tgy
    }})
    this.tlFour.to(this.tweenObj.fourStar, 1, {tgx: 10, tgy: 10, ease: 'expo.inOut' })
    this.tlFour.to(this.tweenObj.fourStar, 2, {tgx: 15,tgy: -10, ease: 'expo.inOut' })
    this.tlFour.to(this.tweenObj.fourStar, 2, {tgx: 10, tgy: 12, ease: 'expo.inOut' })
    this.tlFour.to(this.tweenObj.fourStar, 2, {tgx: -20, tgy: -5, ease: 'expo.inOut' })
    this.tlFour.to(this.tweenObj.fourStar, 2, {tgx: 10, tgy: -13, ease: 'expo.inOut' })
    this.tlFour.to(this.tweenObj.fourStar, 3, {tgx: 0, tgy: 0, ease: 'expo.inOut' }) 



    this.tlThree = gsap.timeline({repeat: -1, paused: true, onUpdate: ()=>{
      this.tgx = this.tweenObj.threeStar.tgx
      this.tgy = this.tweenObj.threeStar.tgy
    }})
    this.tlThree.to(this.tweenObj.threeStar, 1 * 0.6, {tgx: 10, tgy: 10, ease: 'power2.inOut' })
    this.tlThree.to(this.tweenObj.threeStar, 2 * 0.6, {tgx: -15,tgy: 10, ease: 'power2.inOut' })
    this.tlThree.to(this.tweenObj.threeStar, 2 * 0.6, {tgx: -10, tgy: -10, ease: 'power3.inOut' })
    this.tlThree.to(this.tweenObj.threeStar, 2 * 0.6, {tgx: 10, tgy: 5, ease: 'power3.inOut' })
    this.tlThree.to(this.tweenObj.threeStar, 2 * 0.6, {tgx: -30, tgy: 0, ease: 'power3.inOut' })
    this.tlThree.to(this.tweenObj.threeStar, 2 * 0.6, {tgx: 0, tgy: 0, ease: 'power3.inOut' }) 



    this.tlTwo = gsap.timeline({repeat: -1, paused: true, onUpdate: ()=>{
      this.tgx = this.tweenObj.twoStar.tgx
      this.tgy = this.tweenObj.twoStar.tgy
    }})
    this.tlTwo.to(this.tweenObj.twoStar, 1 * .4, {tgx: 10, tgy: 10, ease: 'power2.inOut' })
    this.tlTwo.to(this.tweenObj.twoStar, 2 * .4, {tgx: -15,tgy: 10, ease: 'power2.inOut' })
    this.tlTwo.to(this.tweenObj.twoStar, 2 * .4, {tgx: -10, tgy: -10, ease: 'power3.inOut' })
    this.tlTwo.to(this.tweenObj.twoStar, 2 * .4, {tgx: 10, tgy: 5, ease: 'power3.inOut' })
    this.tlTwo.to(this.tweenObj.twoStar, 2 * .4, {tgx: -2,tgy: -2, ease: 'power2.inOut' })
    this.tlTwo.to(this.tweenObj.twoStar, 2 * .4, {tgx: 8, tgy: -17, ease: 'power3.inOut' })
    this.tlTwo.to(this.tweenObj.twoStar, 2 * .5,  {tgx: 1, tgy: 22, ease: 'expo.inOut' })
    this.tlTwo.to(this.tweenObj.twoStar, 3 * .4, {tgx: 0, tgy: 0, ease: 'power3.inOut' }) 



    this.tlOne = gsap.timeline({repeat: -1, paused: true, onUpdate: ()=>{
      this.tgx = this.tweenObj.oneStar.tgx
      this.tgy = this.tweenObj.oneStar.tgy
    }})
    this.tlOne.to(this.tweenObj.oneStar, 1 * .25, {tgx: 10, tgy: 10, ease: 'power3.out' })
    this.tlOne.to(this.tweenObj.oneStar, 2 * .25, {tgx: -15,tgy: 10, ease: 'power3.out' })
    this.tlOne.to(this.tweenObj.oneStar, 2 * .25, {tgx: -10, tgy: -10, ease: 'power4.out' })
    this.tlOne.to(this.tweenObj.oneStar, 1 , {tgx: 10, tgy: 5, ease: 'expo.inOut' })
    this.tlOne.to(this.tweenObj.oneStar, 2 * .25, {tgx: -20, tgy: 5, ease: 'power3.out' })
    this.tlOne.to(this.tweenObj.oneStar, 3 * .25, {tgx: 0, tgy: 0, ease: 'power3.inOut' }) 

  } 

  setFaceYScale(value = 50){ 
    gsap.killTweensOf(this.sprite.mesh.scale)
    gsap.to(this.sprite.mesh.scale, { 
      duration: AnimationConfig.home.section.duration * 0.5,
      y: value, 
      ease: 'sine.inOut'
    })
  }
 
  addGUI() {
    if(this.gui){
      let folder = this.gui.addFolder('Characters Face') 
      folder.add(this.options.offset, 'x', -200, 200).step(0.01).onChange(this.onGUIChange) 
      folder.add(this.options.offset, 'y', -2, 2).step(0.01).onChange(this.onGUIChange) 
    }
  }

  onGUIChange = () => {
   // this.faceTexture.offset.set( this.options.offset.x, this.options.offset.y)
  //  this.faceTexture.needsUpdate = true
  }
  
  pointerMove(){ 
    const current_section = AppStore.state.home.current_section
    if(
      this.reduced_motion || 
      Env.touch_device || 
      ( current_section && current_section.index === 0 )
    ){
      return
    }

    let easedY = this.expoOut( Math.abs(Pointer.polar.y) )
    let easedX = this.expoOut( Math.abs(Pointer.polar.x) )
    let rotMaxY = (5 * -Pointer.polar.y * easedY) 
    let rotMaxX = (20 * -Pointer.polar.x * easedX) 
    this.pointer.tgx = rotMaxY 
    this.pointer.tgy = rotMaxX 

    this.followMouse()
  }

  pointerStart(event){ }

  pointerEnd(event){ }

  followMouse(){
    this.mouseThrottle++ 
    if((this.mouseThrottle % 20) === 1){  
      gsap.killTweensOf(this.unFollowMouse)
      gsap.delayedCall(1, this.unFollowMouse)
      gsap.to(this.tweenObj, 1, { mixAmt: 0, ease: 'expo.out'})
    }
  }

  unFollowMouse = () => { 
    gsap.killTweensOf(this.tweenObj, { mixAmt: true})
    gsap.to(this.tweenObj, 1, { mixAmt: 1})  
  }



  // UPDATES -------------------------------------------------------------------
  
 
  tick( ) { 
    if(this.render){  

      let mixY = mix(this.pointer.tgy, this.tgy, this.tweenObj.mixAmt)
      let mixX = mix(this.pointer.tgx, this.tgx, this.tweenObj.mixAmt) 
      let tgy = (mixY + this.tweenObj.offset.y) * DEG_TO_RAD
      let tgx = (mixX) * DEG_TO_RAD
      let friction = this.reduced_motion ? 1 : 0.25
      this.face_sphere.rotation.x += (tgx - this.face_sphere.rotation.x) * friction
      this.face_sphere.rotation.y += (tgy - this.face_sphere.rotation.y) * friction 
    }
  }

  resize() {
    let ww = window.innerWidth
    let wh = window.innerHeight
  } 

  destroy(){}

  mainLoaded(){
 

    var face_geometry = new THREE.SphereGeometry( 0.235, 32, 32 );
    // var face_material = new THREE.MeshBasicMaterial( { 
    //   map: texture2,  
    //   fog: false,
    //   transparent: true, 
    //   depthTest: false 
    // })

    this.faceTexture = new THREE.Texture(ImageService.get(require('@/assets/imgs/spritesheets/face.png')) )
    this.faceTexture.needsUpdate = true 

    this.sprite = new Sprite({  
      data: SpritesheetData, 
      renderer: this.renderer,  
      texture: this.faceTexture
    }) 

    this.material = new THREE.MeshBasicMaterial( { 
      map: this.sprite.rTexture.texture,
      transparent: true, 
      depthTest: false,
      opacity: 0 
    })
    this.face_sphere = new THREE.Mesh( face_geometry, this.material )
    this.face_sphere.position.y = 1.04
    this.face_sphere.position.z = 0.01 
    this.add(this.face_sphere) 

    this.render = true
    this.sprite.gotoAndStop(0)

  }

  enter(){ }

  leave(){ }



  // HANDLERS -------------------------------------------------------------------



  // STATES -------------------------------------------------------------------

  /* modal states */

  /*  
    none
    menu
    video
  */

  /* page states */

  routeLoading(){ } 
 
  routeHome(){ }

  checkJump(val, prev, dir){
    let jump = dir !== 0 && Math.abs(val.index - prev.index) > 1 || this.reduced_motion
    return jump
  }

  playTl(tl){

    if(this.reduced_motion){
      return
    }

    if(this.prevTl){
      this.prevTl.pause()
    }
    tl.play() 
    this.prevTl = tl
  }

  getDuration(duration){ 
    let clamp = this.reduced_motion ? 0 : 1
    return ( duration * clamp )
  }

  killTweens(){
    this.sprite.killTweens()

    gsap.killTweensOf([
      this.onHideFace, 
      this.onShowFace, 
      this.onTransitionDelay, 
      this.onTransitionLoopIn, 
      this.onTransitionLoopOut, 
      this.onPlaybackComplete,
      this.onTransitionLoopInComplete,
      this.onTransitionLoopOutComplete
    ])
  }

  transition(){

    const home = AppStore.state.home 
    const isMenuModeDefault = ( home.mode === HOME.MODES.MENU_EXPLORE ) 
    
    this.killTweens()

    // window.console.log('this.prev_transition_options - ', this.prev_transition_options)

    if(this.prev_transition_options !== null && this.loopIn){
      let options = this.prev_transition_options
      this.sprite.gotoAndPlayRange(this.sprite.frame.current, options.loop.stop) 
      this.loopIn = false
    }

    gsap.delayedCall( this.getDuration(1), this.onShowFace)

    // start transition
    let delay
    if( isMenuModeDefault ){
      delay = 0
    } else {
      if(this.transition_options.dir === 0) {
        delay = 1
      } else if(this.transition_options.isJump){
        delay = 0
      } else {
        delay = AnimationConfig.home.section.duration
      }
    }
    
    gsap.delayedCall(this.getDuration(delay), this.onTransitionDelay)
  }

  onTransitionDelay = () => { 

    // window.console.log('onTransitionDelay')

    let options = this.transition_options 
    if(options.isJump || this.reduced_motion){
      this.sprite.gotoAndStop(options.transition.stop)
      //window.console.log('SET :: onTransitionDelay')
    } else { 
      let start = options.transition.start 
      let stop = options.transition.stop  
      this.sprite.gotoAndPlayRange( start, stop, this.onPlaybackComplete, 1)
      // window.console.log('PLAY :: onTransitionDelay')
    }
  }

  onPlaybackComplete = () => {    

    // window.console.log('onPlaybackComplete')

    let options = this.transition_options
    let delay = options.loop.delay ? 3 + (Math.random() * 2) : 0
    gsap.delayedCall(this.getDuration(delay), this.onTransitionLoopIn) 
  }

  onTransitionLoopIn = () => { 

    let options = this.transition_options

    // return if nothing to loop
    if( !options.loop.active ){
      return
    }

    // window.console.log('onTransitionLoopIn')

    this.loopIn = true

    this.sprite.gotoAndPlayRange(options.loop.start, options.loop.center, this.onTransitionLoopInComplete, 1) 
  }

  onTransitionLoopInComplete = () => { 

    // window.console.log('onTransitionLoopInComplete')

    let options = this.transition_options 
    let delay = options.loop.delay ? (1 + Math.random()) : 0
    gsap.delayedCall(this.getDuration(delay), this.onTransitionLoopOut) 
  }

  onTransitionLoopOut = () => {

    // window.console.log('onTransitionLoopOut')

    let options = this.transition_options
    this.sprite.gotoAndPlayRange(options.loop.center, options.loop.stop, this.onTransitionLoopOutComplete, 1) 
  }

  onTransitionLoopOutComplete = () => { 

    // window.console.log('onTransitionLoopOutComplete')

    this.loopIn = false

    let options = this.transition_options 
    let delay = options.loop.delay ? (5 + (Math.random() * 2)) : 0
    gsap.delayedCall(delay, this.onTransitionLoopIn)
  }

  onHideFace = () => {
    //this.material.opacity = 0 
  }

  onShowFace = () => {
    //this.material.opacity = 1
  }
  

  /* home states */
 
  welcome(val, prev){  

    gsap.killTweensOf([this.onHideFace, this.onShowFace, this.material, this.tweenObj.offset])

    const duration = this.getDuration(AnimationConfig.home.section.duration * 0.5)
    gsap.to(this.tweenObj.offset, duration, { y: -200 })  
    gsap.to(this.material, { 
      duration: duration * 0.25,
      delay: duration * 0.1, 
      ease: 'Sine.easeInOut',
      opacity: 0
    })   
    //gsap.delayedCall(this.getDuration(duration * 0.5), this.onHideFace)
 

    if(this.prevTl){
      this.prevTl.pause()
    }
    this.setFaceYScale(50)
  } 
 
  ratingFive(val, prev, dir){  
    this.prev_transition_options = this.transition_options 
    this.transition_options = {
      isJump: this.checkJump(val, prev, dir), 
      dir: dir,
      loop: { active: true, delay: true, start: 0, center: 25 , stop: 50 },
      transition: { start: 0, stop: 50 }
    }
    this.unFollowMouse()
    this.transition()  
    if(dir === -1){
      this.playTl(this.tlFive)
      this.onShowFace()
    } else{
      gsap.killTweensOf([this.material, this.tweenObj.offset])
      let duration = this.getDuration(AnimationConfig.home.section.duration )
      gsap.to(this.tweenObj.offset, {
        duration: duration * 0.5,
        delay: duration * 0.6, 
        y: -90, 
        ease: 'back.out(3)',
        onComplete: ()=>{ 
          this.playTl(this.tlFive)
        }
      })
      gsap.to(this.material, { 
        duration: duration * 0.25,
        delay: duration * 0.5, 
        ease: 'Sine.easeInOut',
        opacity: 1
      })  
    } 
    this.setFaceYScale(50)
  }  


  ratingFour(val, prev, dir){ 
    this.prev_transition_options = this.transition_options
    this.transition_options = {
      isJump: this.checkJump(val, prev, dir), 
      dir: dir,
      loop: { active: false, delay: true, start:57 , center: 75, stop: 100 },
      transition: { 
        start: (dir === 1) ? 50 : 110, 
        stop: (dir === 1) ? 57 : 100
      }
    }
    this.transition()
    this.playTl(this.tlFour)
    this.onShowFace() 
    this.setFaceYScale(50)
  } 
 
  ratingThree(val, prev, dir){ 
    this.prev_transition_options = this.transition_options
    this.transition_options = {
      isJump: this.checkJump(val, prev, dir), 
      dir: dir,
      loop: { active: false, delay: true, start: 110, center: 130, stop: 150 },
      transition: {
        start: dir === 1 ? 100 : 150, 
        stop: 110 
      }
    }
    this.transition()
    this.playTl(this.tlThree)
    this.onShowFace() 
    this.setFaceYScale(45)
  }

  ratingTwo(val, prev, dir){ 
    this.prev_transition_options = this.transition_options
    this.transition_options = {
      isJump: this.checkJump(val, prev, dir), 
      dir: dir,
      loop: { active: true, delay: false, start: 161, center: 170, stop: 198 }, 
      transition: {
        start: dir === 1 ? 150 : 200, 
        stop: 161
      }
    }
    this.transition()
    this.playTl(this.tlTwo)
    this.onShowFace() 
    this.setFaceYScale(60)
  } 
 
  ratingOne(val, prev, dir){ 
    this.prev_transition_options = this.transition_options
    this.transition_options = {
      isJump: this.checkJump(val, prev, dir), 
      dir: dir, 
      loop: { active: true, delay: true, start: 229, center: 237, stop: 255 },
      transition: { start: 200, stop: 229 }
    }
    this.transition()
    this.playTl(this.tlOne)
    this.onShowFace()
    this.setFaceYScale(75)
  } 

  cta(val, prev){ 
    gsap.killTweensOf([this.onHideFace, this.onShowFace])
    gsap.delayedCall(this.getDuration(1), this.onHideFace)
  } 

}
 

export default Bubble